import { getMatchingAttributeConfig } from "api/getMatchingAttributeConfig";

import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { SiteSurveyUnit } from "api/types/siteSurveyUnit";
import { getUnitTitle } from "../helpers";

export function UnitSummary({
  config,
  unit,
}: {
  config: SiteSurveyConfiguration;
  unit: SiteSurveyUnit;
}) {
  return (
    <div className="mt-2">
      <h3>{getUnitTitle(unit)}</h3>
      {unit.attributes && (
        <div className="d-flex justify-content-center">
          <div className=" p-2" style={{ width: "70%" }}>
            <table className="table table-borderless table-striped table-sm ">
              <tbody>
                <AttributeNameValue name={"Model"} value={unit.modelNumber} />
                <AttributeNameValue name={"Serial"} value={unit.serialNumber} />

                {unit.attributes.map((attribute, index) => {
                  const attributeConfig = getMatchingAttributeConfig(
                    config.unitConfiguration.attributes,
                    attribute
                  );
                  return (
                    <AttributeNameValue
                      key={`unitAttribute-${index}-${attribute.id}`}
                      name={attributeConfig.text}
                      value={attribute.attributeValue}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function AttributeNameValue({ name, value }) {
  return (
    <tr>
      <td>{name}</td>
      <td>{value}</td>
    </tr>
  );
}
